import { FOLLOW_UP_STATUSES, TERMINAL_STATUSES } from '@/constants/discipline/timelineConfig';

export const OBLIGATION_STATES = Object.freeze({
  OUTSTANDING: 'outstanding',
  COMPLETED: 'completed',
  EXCUSED: 'excused',
  VOIDED: 'voided',
});

export function resolveObligationState(event = {}) {
  const record = event.originalData || event;
  const status = String(event.status || record.status || '').toLowerCase();
  const attendanceStatus = String(
    event.attendanceStatus || record.attendanceStatus || ''
  ).toLowerCase();
  const adjudicationStatus = String(
    event.adjudicationStatus || record.adjudicationStatus || ''
  ).toLowerCase();

  if (
    record.voided === true ||
    record.deleted === true ||
    status === 'voided' ||
    adjudicationStatus === 'voided'
  ) {
    return OBLIGATION_STATES.VOIDED;
  }

  if (status === 'excused') {
    return OBLIGATION_STATES.EXCUSED;
  }

  if (
    ['served', 'late', 'archived'].includes(status) ||
    ['attended', 'late'].includes(attendanceStatus)
  ) {
    return OBLIGATION_STATES.COMPLETED;
  }

  return OBLIGATION_STATES.OUTSTANDING;
}

export function isOutstandingObligation(event = {}) {
  if (!['disciplineQueue', 'queue'].includes(event.sourceCollection)) return false;
  const record = event.originalData || event;
  if (record.adjudicationStatus === 'pending' || event.adjudicationStatus === 'pending') {
    return false;
  }
  if ((event.followUpStatus || record.followUpStatus) === 'completed') return false;
  return resolveObligationState(event) === OBLIGATION_STATES.OUTSTANDING;
}

export function requiresActionForEvent(event = {}, eventTypeConfig = {}) {
  const type = event.consequenceType || event.type || event.value;
  const configured = eventTypeConfig[type];
  if (typeof configured?.requiresAction === 'boolean') {
    return configured.requiresAction;
  }
  return event.requiresAction === true || event.originalData?.requiresAction === true;
}

export function isOutstandingActionObligation(event = {}, eventTypeConfig = {}) {
  return requiresActionForEvent(event, eventTypeConfig) && isOutstandingObligation(event);
}

export function canExcuseObligation(event = {}, eventTypeConfig = {}) {
  return isOutstandingActionObligation(event, eventTypeConfig);
}

export function obligationStatePresentation(event = {}) {
  const state = resolveObligationState(event);
  const presentations = {
    [OBLIGATION_STATES.OUTSTANDING]: {
      label: 'Outstanding',
      className: 'badge-warning badge-outline'
    },
    [OBLIGATION_STATES.COMPLETED]: {
      label: 'Completed',
      className: 'badge-success badge-outline'
    },
    [OBLIGATION_STATES.EXCUSED]: {
      label: 'Excused',
      className: 'badge-neutral badge-outline'
    },
    [OBLIGATION_STATES.VOIDED]: {
      label: 'Voided',
      className: 'badge-error badge-outline'
    },
  };
  return presentations[state];
}

export function isTerminalObligationStatus(status) {
  return TERMINAL_STATUSES.includes(status) && !FOLLOW_UP_STATUSES.includes(status);
}
